"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getObjType = void 0;
var upperFirst_1 = __importDefault(require("licia/upperFirst"));
function getObjType(obj) {
    if (obj.constructor && obj.constructor.name)
        return obj.constructor.name;
    return (0, upperFirst_1.default)({}.toString.call(obj).replace(/(\[object )|]/g, ''));
}
exports.getObjType = getObjType;
